export class GetQuotationItemModel {
    limit: number = 0;
    page: number = 0;
    sorttype: number = 0;
    sortcol: string = "";
    quowin: boolean = false;
    quolost: boolean = false;
    quofollow: boolean = false;
    quowait: boolean = false;
    quorevise: boolean = false;
    quotrash: boolean = false;
    startdate: Date = new Date();
    enddate: Date = new Date();
    category: string = "0";
    itemsearch: string = "";
    companysearch: string = "";
    prospectsearch: string = "";
    projectsearch: string = "";
}
export class QuotaionItemlistModelIndexModel {
    data: Array<QuotaionItemlistModel> = new Array<QuotaionItemlistModel>();
    count: number = 0;
}
export class QuotaionItemlistModel {
    quotationItemSurrkey: number = 0;
    quotationCode: string = "";
    docdate: Date = new Date();
    itemname: string = "";
    quantity: number = 0;
    unit: string = "";
    unitPrice: number = 0;
    amout: number = 0;
    companyname: string = "";
    prospectname: string = "";
    projectname: string = "";
    category: string = "";
    quostatus: number = 0;
}

export class CategoriesQoIndexModel {
    data: Array<CategoriesQuotation> = new Array<CategoriesQuotation>();
    count: number = 0;
}
export class CategoriesQuotation {
    cateSurrkey: number = 0;
    cateName: string = "";
}


